import * as React from 'react';
import { AppReviewCollection as AppReviewCollectionComponent } from '@appsource/components/appReviewCollection';
import { ensureAppReviewsData, loadUserMarkedAsHelpfulReviews, setReviewMarkedAsHelpful, loadUserProductReviewMetadata } from '@shared/actions/thunkActions';
import { createModalAction, createRatingAction } from '@shared/actions/actions';
import { Constants } from '@shared/utils/constants';
import { connect } from 'react-redux';
import { withRouter } from '@shared/routerHistory';
export const mapStateToProps = (state, ownProps)=>{
    var _state_config_query;
    return {
        reviewsData: state.apps.appReviewsData,
        appId: ownProps.appId,
        locale: state.config.locale,
        appData: ownProps.appData,
        location: ownProps.location,
        reviewId: (_state_config_query = state.config.query) === null || _state_config_query === void 0 ? void 0 : _state_config_query.reviewId,
        userInfo: state.users,
        markedAsHelpful: state.apps.appReviewsData.markedAsHelpful,
        userCommentedReviewIds: state.apps.appReviewsData.userCommentedReviewIds,
        billingCountryCode: state.config.billingCountryCode,
        showMyCommentsFilter: state.config.featureFlags.ReviewsMyCommentsFilter === 'true',
        isConverged: state.config.isConverged
    };
};
const mapDispatchToProps = (dispatch)=>{
    return {
        ensureAppReviewsData: (entityId, forceUpdate = false)=>dispatch(ensureAppReviewsData(entityId, forceUpdate)),
        openRatingModal: (app, accessKey, ctaType, callback)=>dispatch(createRatingAction({
                showModal: true,
                app: app,
                accessKey: accessKey,
                ctaType: ctaType,
                callback: callback
            })),
        openSignInModal: ()=>dispatch(createModalAction({
                showModal: true,
                modalId: Constants.ModalType.SignIn
            })),
        toggleMarkAsHelpful: (args)=>dispatch(setReviewMarkedAsHelpful(args)),
        loadReviewIdsMarkedAsHelpful: (args)=>dispatch(loadUserMarkedAsHelpfulReviews(args)),
        loadUserProductReviewMetadata: (args)=>dispatch(loadUserProductReviewMetadata(args))
    };
};
export const AppReviewCollection = withRouter(connect(mapStateToProps, mapDispatchToProps)(AppReviewCollectionComponent));
